import { firestoreAction } from 'vuexfire'

const state = {
  flightBookings: [],
  hotelBookings: []
}

const mutations = {

}

const getters = {
  getFlightBookings: state => state.flightBookings,
  getFlightBookingsForUser: state => (user) => {
    if (user && user.claims && user.claims.role === 'agent') {
      let result = state.flightBookings.filter(booking => booking.metadata && booking.metadata.agent && booking.metadata.agent === user.claims.user_id);
      return result
    }
    return state.flightBookings;
  },
  getHotelBookings: state => state.hotelBookings,
  getHotelBookingsForUser: state => user => {
    if (user && user.claims && user.claims.role === 'agent') {
      let result = state.hotelBookings.filter(booking => booking.metadata && booking.metadata.agent && booking.metadata.agent === user.claims.user_id);
      return result;
    }
    return state.hotelBookings;
  }
}

const actions = {

  setFlightBookingsRef : firestoreAction(
    ({bindFirestoreRef}, ref) => {
      bindFirestoreRef('flightBookings', ref);
    }
  ),
  setHotelBookingsRef : firestoreAction(
    ({bindFirestoreRef}, ref) => {
      bindFirestoreRef('hotelBookings', ref);
    }
  ),

}

export default {
  state,
  mutations,
  getters,
  actions
}